import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('jv-badge')
export class JvBadge extends LitElement {
  static styles = css`
    :host {
      display: inline-flex;
    }
    span {
      display: inline-flex;
      align-items: center;
      padding: 0.15rem 0.5rem;
      border-radius: var(--jv-radius);
      background: transparent;
      color: var(--jv-color-accent);
      font-family: var(--jv-font-mono);
      font-size: var(--jv-fs-xs);
      font-weight: var(--jv-fw-medium);
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }
    span::before {
      content: '[ ';
    }
    span::after {
      content: ' ]';
    }
    :host([tone='sand']) span {
      color: var(--jv-color-muted);
    }
    :host([tone='amber']) span {
      color: var(--jv-color-amber-hover);
    }
    :host([tone='solid']) span {
      background: var(--jv-color-ink);
      color: var(--jv-color-on-ink);
      border: var(--jv-border-w) solid var(--jv-color-border);
    }
    :host([tone='solid']) span::before,
    :host([tone='solid']) span::after {
      content: '';
    }
  `;

  @property({ reflect: true }) tone: 'accent' | 'sand' | 'amber' | 'solid' = 'accent';

  render() {
    return html`<span><slot></slot></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-badge': JvBadge;
  }
}
